import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SignupModal from './SignupModal';
import LoginModal from './LoginModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import Search from './Search';
import CoinInfo from './CoinInfo';
// import Onboarding from './Onboarding';
import FavoriteModal from './FavoriteModal';
import { CardFilterModal, FlyerFilterModal } from './FilterModal';
// import EventPricingModal from './../Delivery/EventPricingModal';
import ComparisonModal from './ComparisonModal';
import PreviewModal from './PreviewModal';
import FlyerPricingModal from './FlyerPricingModal';

import TakeoverModal from './ModalContainers/TakeoverModal';
import BackdropModal from './ModalContainers/BackdropModal';

import {
  closeCoinProductsModal,
  closeEventPricingModal,
  closeFavoriteModal,
  closeForgotPasswordModal,
  closeLogInModal,
  closeOnboardingModal,
  closeSearchModal,
  closeSignUpModal,
  closeCardFilterModal,
  closeFlyerFilterModal,
  closeComparisonModal,
  closePreviewModal,
  closeFlyerPricingModal,
} from '../../../redux/modals';

export class Modals extends Component {
  static propTypes = {
    coinProductsModalOpen: PropTypes.bool,
    eventPricingModalOpen: PropTypes.bool,
    favoriteModalOpen: PropTypes.bool,
    forgotPasswordModalOpen: PropTypes.bool,
    isMobile: PropTypes.bool,
    logInModalOpen: PropTypes.bool,
    onboardingModalOpen: PropTypes.bool,
    searchModalOpen: PropTypes.bool,
    signUpModalOpen: PropTypes.bool,
    cardFilterModalOpen: PropTypes.bool,
    comparisonModalOpen: PropTypes.bool,
    previewModalOpen: PropTypes.bool,
    flyerPricingModalOpen: PropTypes.bool,
  };

  getCurrentModalConfig() {
    const {
      closeCoinProductsModal,
      closeEventPricingModal,
      closeFavoriteModal,
      closeForgotPasswordModal,
      closeLogInModal,
      closeOnboardingModal,
      closeSearchModal,
      closeSignUpModal,
      closeCardFilterModal,
      closeFlyerFilterModal,
      closeComparisonModal,
      closePreviewModal,
      closeFlyerPricingModal,
      coinProductsModalOpen,
      eventPricingModalOpen,
      favoriteModalOpen,
      forgotPasswordModalOpen,
      logInModalOpen,
      onboardingModalOpen,
      searchModalOpen,
      signUpModalOpen,
      cardFilterModalOpen,
      flyerFilterModalOpen,
      comparisonModalOpen,
      previewModalOpen,
      flyerPricingModalOpen,
    } = this.props;

    if (searchModalOpen) {
      return {
        content: Search,
        closeAction: closeSearchModal,
        useAltCloseButton: true,
      };
    } else if (coinProductsModalOpen) {
      return {
        content: CoinInfo,
        closeAction: closeCoinProductsModal,
      };
    } else if (logInModalOpen) {
      return {
        content: LoginModal,
        closeAction: closeLogInModal,
      };
    } else if (signUpModalOpen) {
      return {
        content: SignupModal,
        closeAction: closeSignUpModal,
      };
    } else if (forgotPasswordModalOpen) {
      return {
        content: ForgotPasswordModal,
        closeAction: closeForgotPasswordModal,
      };
      // } else if (onboardingModalOpen) {
      //   return {
      //     content: Onboarding,
      //     closeAction: closeOnboardingModal,
      //   };
    } else if (favoriteModalOpen) {
      return {
        content: FavoriteModal,
        closeAction: closeFavoriteModal,
      };
      // } else if (eventPricingModalOpen) {
      //   return {
      //     content: EventPricingModal,
      //     closeAction: closeEventPricingModal,
      //   };
    } else if (cardFilterModalOpen) {
      return {
        content: CardFilterModal,
        closeAction: closeCardFilterModal,
        useAltCloseButton: true,
        slideIn: true,
      };
    } else if (flyerFilterModalOpen) {
      return {
        content: FlyerFilterModal,
        closeAction: closeFlyerFilterModal,
        useAltCloseButton: true,
        slideIn: true,
      };
    } else if (comparisonModalOpen) {
      return {
        content: ComparisonModal,
        className: 'pp-flyer-comparison-modal',
        closeAction: closeComparisonModal,
      };
    } else if (previewModalOpen) {
      return {
        content: PreviewModal,
        className: 'pp-card-preview-modal',
        closeAction: closePreviewModal,
      };
    } else if (flyerPricingModalOpen) {
      return {
        content: FlyerPricingModal,
        className: 'pp-flyer-pricing-modal',
        closeAction: closeFlyerPricingModal,
      };
    } else {
      return null;
    }
  }

  render() {
    const { isMobile } = this.props;
    const activeModalConfig = this.getCurrentModalConfig();

    if (activeModalConfig) {
      const {
        className,
        closeAction,
        useAltCloseButton,
        slideIn,
      } = activeModalConfig;

      if (isMobile) {
        // TakeoverModal is used on mobile and fills the entire screen with a white backdrop
        return (
          <TakeoverModal
            className={className}
            closeAction={closeAction}
            useAltCloseButton={!!useAltCloseButton}
            slideIn={slideIn}
          >
            <activeModalConfig.content isMobile={true} />
          </TakeoverModal>
        );
      } else {
        // BackdropModal is used on desktop and creates a transparent gray backdrop with a white content box
        return (
          <BackdropModal
            className={className}
            closeAction={closeAction}
            useAltCloseButton={!!useAltCloseButton}
          >
            <activeModalConfig.content isMobile={false} />
          </BackdropModal>
        );
      }
    } else {
      return null;
    }
  }
}

const mapStateToProps = ({
  modals: {
    coinProductsModalOpen,
    eventPricingModalOpen,
    favoriteModalOpen,
    forgotPasswordModalOpen,
    logInModalOpen,
    onboardingModalOpen,
    searchModalOpen,
    signUpModalOpen,
    cardFilterModalOpen,
    flyerFilterModalOpen,
    comparisonModalOpen,
    previewModalOpen,
    flyerPricingModalOpen,
  },
  env: { isMobile },
}) => ({
  isMobile,
  coinProductsModalOpen,
  eventPricingModalOpen,
  favoriteModalOpen,
  forgotPasswordModalOpen,
  logInModalOpen,
  onboardingModalOpen,
  searchModalOpen,
  signUpModalOpen,
  cardFilterModalOpen,
  flyerFilterModalOpen,
  comparisonModalOpen,
  previewModalOpen,
  flyerPricingModalOpen,
});

const mapDispatchToProps = {
  closeCoinProductsModal,
  closeEventPricingModal,
  closeFavoriteModal,
  closeForgotPasswordModal,
  closeLogInModal,
  closeOnboardingModal,
  closeSearchModal,
  closeSignUpModal,
  closeCardFilterModal,
  closeFlyerFilterModal,
  closeComparisonModal,
  closePreviewModal,
  closeFlyerPricingModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
